import "normalize.css/normalize.css";
import "element-ui/lib/theme-chalk/index.css";
import 'swiper/css/swiper.css'
import VueASwiper from "vue-awesome-swiper";

import Vue from "vue";
import App from "./App";
import store from "./store";
import router from "./router";
import i18n from "@/utils/i18n";
import ElementUI from "element-ui";

import "babel-polyfill";


Vue.use(VueASwiper);
Vue.use(ElementUI);

Vue.config.productionTip = false;

//引入axios配置 原型绑定
// 国内
import HttpService from "./service/HttpService";
Vue.prototype.$http = HttpService;


import Lodash from "lodash";
Vue.prototype.$lodash = Lodash;

ElementUI.i18n((key, value) => i18n.t(key, value));

new Vue({
  el: "#app",
  i18n,
  store,
  router,
  components: { App },
  template: "<App/>",
});



// WEBPACK FOOTER //
// ./src/main.js